// extracted by mini-css-extract-plugin
export default {"receipt_card":"Receipt_receipt_card__ERtqh","receipt_img":"Receipt_receipt_img__XQs8c"};